// extracted by mini-css-extract-plugin
export default {"rightPanel":"Statistics_rightPanel__V+X01","iFrameLoading":"Statistics_iFrameLoading__pZEoa","iframe":"Statistics_iframe__ptCRk"};